

module.exports = __webpack_require__.stylable.create(
    "Widget4018372463",
    {"classes":{"root":"Widget4018372463__root","dynamicWrapper":"Widget4018372463__dynamicWrapper","Body":"","Sidebar":""},"vars":{},"stVars":{},"keyframes":{}},
    "",
    12,
    "Widget4018372463",
    null
);
